var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-info-layers__simple-button",on:{"click":_vm.toggleLayer}},[_c('el-tooltip',{attrs:{"open-delay":1500,"content":_vm.title,"placement":"bottom"}},[_c('r-icon',{attrs:{"name":_vm.icon,"size":24,"color-type":_vm.isThisLayerActive ? 'accent-primary' : ''}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }